import * as React from "react";

import { ConfirmationContainer } from "../../../../containers/booking";
import { Column, Container, Row } from "../../../grid";

const ConfirmationPageContainer = Container.extend`
  padding-top: 50px;
`;

const ConfirmationPage: React.FC = () => {
  return (
    <ConfirmationPageContainer>
      <Row>
        <Column textAlign="center">
          <ConfirmationContainer />
        </Column>
      </Row>
    </ConfirmationPageContainer>
  );
};

export { ConfirmationPage };
